export default __webpack_public_path__ + "static/media/BgGroup38288.4050b0e5.png";